import RightArrowIcon from './RightArrowIcon'

export default RightArrowIcon
